"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const edge_1 = require("../edge");
class UndirectedEdge extends edge_1.Edge {
    draw(ctx, grid) {
        super.draw(ctx, grid);
        let fromCoord = grid.getCoordinate(this.startNode);
        let toCoord = grid.getCoordinate(this.endNode);
        ctx.beginPath();
        ctx.moveTo(fromCoord[1], fromCoord[0]);
        ctx.lineTo(toCoord[1], toCoord[0]);
        ctx.stroke();
        ctx.closePath();
    }
    equals(other) {
        if (other == null)
            return false;
        let result = (other.getStartNode() == this.startNode && other.getEndNode() == this.endNode)
            || (other.getStartNode() == this.endNode && other.getEndNode() == this.startNode);
        return result;
    }
}
exports.UndirectedEdge = UndirectedEdge;
